import { render, staticRenderFns } from "./CategoryUpdateDialogBasicData.vue?vue&type=template&id=7294a856&scoped=true"
import script from "./CategoryUpdateDialogBasicData.vue?vue&type=script&lang=ts"
export * from "./CategoryUpdateDialogBasicData.vue?vue&type=script&lang=ts"
import style0 from "./CategoryUpdateDialogBasicData.vue?vue&type=style&index=0&id=7294a856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7294a856",
  null
  
)

export default component.exports